// src/components/ProjectForm.tsx
// نام فایل: ProjectForm.tsx

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

interface ProjectFormProps {
  onSubmit: (title: string, description?: string) => Promise<void>;
  onCancel?: () => void;
  initialTitle?: string;
  initialDescription?: string;
}

export default function ProjectForm({
  onSubmit,
  onCancel,
  initialTitle = "",
  initialDescription = "",
}: ProjectFormProps) {
  const [title, setTitle] = useState(initialTitle);
  const [description, setDescription] = useState(initialDescription);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(title, description);
    setTitle("");
    setDescription("");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="apGlobal"
      style={{
        marginTop: 10,
        marginBottom: 10,
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        alignItems: "center",
        background: "var(--app-card-bg-color)",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid var(--app-border-color)",
        color: "var(--app-text-color)",
      }}
    >
      <input
        type="text"
        placeholder="عنوان پروژه"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
        style={{
          flex: "1 1 200px",
          padding: "6px 10px",
          borderRadius: "6px",
          border: "1px solid var(--app-border-color)",
          background: "var(--app-input-bg-color)",
          color: "var(--app-text-color)",
        }}
      />
      <input
        type="text"
        placeholder="شرح پروژه"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        style={{
          flex: "2 1 300px",
          padding: "6px 10px",
          borderRadius: "6px",
          border: "1px solid var(--app-border-color)",
          background: "var(--app-input-bg-color)",
          color: "var(--app-text-color)",
        }}
      />
      <button
        type="submit"
        style={{
          padding: "6px 10px",
          borderRadius: 6,
          border: "1px solid var(--app-border-color)",
          background: "var(--app-button-bg-color)",
          color: "var(--app-text-color)",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        <FontAwesomeIcon icon={faPlus} /> ذخیره
      </button>
      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          style={{
            padding: "6px 10px",
            borderRadius: 6,
            border: "1px solid var(--app-border-color)",
            background: "var(--app-button-bg-color)",
            color: "var(--app-text-color)",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          <FontAwesomeIcon icon={faTimes} /> لغو
        </button>
      )}
    </form>
  );
}
